export var IncomeTypesAsset;
(function (IncomeTypesAsset) {
    IncomeTypesAsset["SelfEmployedBusinessIncome"] = "SELF_EMPLOYED_BUSINESS_INCOME";
    IncomeTypesAsset["RentalIncome"] = "RENTAL_INCOME";
    IncomeTypesAsset["InvestmentIncome"] = "INVESTMENT_INCOME";
})(IncomeTypesAsset || (IncomeTypesAsset = {}));
//# sourceMappingURL=IncomeTypesAsset.js.map